import * as React from "react";
import { Link } from "react-router-dom";
import {
  ZPrimSchemaLinkItem,
  ZSecondarySchemaLinkClass,
} from "src/business/specification";
import { columnDisplayId } from "src/business/sysData/sysColumns";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const specLinksPrimaryCatalogsColumns: RtColumn<ZPrimSchemaLinkItem>[] =
  [
    columnDisplayId,
    {
      key: "name",
      title: "Название",
      render: (row) => (
        <Link to={makeUrl(PageUrl.managementCatalogEdit, { id: row.id })}>
          {row.name}
        </Link>
      ),
    },
  ];

export const specLinksPrimaryClassifiersColumns: RtColumn<ZPrimSchemaLinkItem>[] =
  [
    columnDisplayId,
    {
      key: "name",
      title: "Название",
      render: (row) => (
        <Link to={makeUrl(PageUrl.managementClassifierCard, { id: row.id })}>
          {row.name}
        </Link>
      ),
    },
  ];
export const specLinksSecondaryClassesColumns: RtColumn<ZSecondarySchemaLinkClass>[] =
  [
    columnDisplayId,
    {
      key: "className",
      title: "Класс",
      render: (row) => (
        <Link to={makeUrl(PageUrl.class, { id: row.id })}>{row.className}</Link>
      ),
    },
    {
      key: "classifierName",
      title: "Классификатор",
      render: (row) => row.classifierName,
    },
  ];
